/**
 * 🚨 GENERATED FILE - DO NOT EDIT DIRECTLY
 * Source: /project_config.json
 */
export const ROUTES = {
  login: '/login',
  register: '/register',
  invite_register: '/invite-register',
  chat: '/chat',
  admin: '/admin',
  setup: '/setup',
};
